module.exports = __webpack_public_path__ + "static/media/47_B.4f762fe6.png";